import { Navbar } from "../components/landing/navbar"
import { Hero } from "../components/landing/hero"
import { FeatureShowcase } from "../components/landing/feature-showcase"
import { ModeGrid } from "../components/landing/mode-grid"
import { IntegrationSection } from "../components/landing/integration-section"
import { CTASection } from "../components/landing/cta-section"
import { Footer } from "../components/landing/footer"

export default function LandingPage() {
  return (
    <main className="min-h-screen bg-background selection:bg-primary/20 selection:text-primary">
      <Navbar />
      <Hero />
      <FeatureShowcase />
      <ModeGrid />
      <IntegrationSection />
      <CTASection />
      <Footer />
    </main>
  )
}
